import GeoblockChecker from "./checker";
import { PlayerAhoyEvent } from "../../player_ahoy_event";

export default class Geoblock {
  constructor(options = {}) {
    this._data = options.data;
    this._blocker = options.blocker;
    this._uuid = options.uuid;
    this._tech = options.tech;
  }

  get data() { return this._data }
  get uuid() { return this._uuid }
  get tech() { return this._tech }
  get blocker() { return this._blocker }

  runAndBlock() {
    let checkerPromise = GeoblockChecker.checkContent(this.data.geoblockUrl());

    checkerPromise.then((blocked) => {
      if(blocked) {
        this.showBlocker(); 
        this.sendEvent();
      }

      this.data.setGeoblocked(blocked);
    });

    return checkerPromise;
  }

  showBlocker() {
    this.tech?.el()?.addClass('vjs-error');
    this.blocker.renderBlocker('geoblock');
  }

  sendEvent() {
    PlayerAhoyEvent.sendGeoblock(this.data.type(), this.data.videoId(), this.uuid);
    PlayerAhoyEvent.sendBlocker(this.data.type().toLowerCase(), this.data.isPremier(), this.data.videoId(), 'geoblock');
  }
}
